'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var RIGHT_RAIL_CSS_VAR_PREFIX = '--right-rail';
var RightRailCssVars = {
  rightRailWidth: "".concat(RIGHT_RAIL_CSS_VAR_PREFIX, "-width"),
  rightRailTransitionEasing: "".concat(RIGHT_RAIL_CSS_VAR_PREFIX, "-transition-easing"),
  rightRailTransitionDuration: "".concat(RIGHT_RAIL_CSS_VAR_PREFIX, "-transition-duration"),
  rightRailTransitionDelay: "".concat(RIGHT_RAIL_CSS_VAR_PREFIX, "-transition-delay")
};
var RIGHT_RAIL_OPENED_WIDTH = 305;
var RIGHT_RAIL_CLOSED_WIDTH = 40;

exports.RIGHT_RAIL_CLOSED_WIDTH = RIGHT_RAIL_CLOSED_WIDTH;
exports.RIGHT_RAIL_OPENED_WIDTH = RIGHT_RAIL_OPENED_WIDTH;
exports.RightRailCssVars = RightRailCssVars;
